import React, { useEffect } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import * as authActions from '../store/actions/auth';
import { getTripCount } from '../store/actions/mytrips';
import { getProfileData } from '../store/actions/profile';

import AsyncStoreService from '../services/async-store.service';
import { guestTokenUserName } from '../constants/Configs';
import { CommonProperties, Color } from '../styles';
import * as Linking from 'expo-linking';
import { userAuthenticate } from '../store/actions/auth';
import { getSSOData } from '../utils/auth.utils';
import { useSetDeepLink } from '../utils/useSetDeepLink';

const StartupScreen = () => {
  const dispatch = useDispatch();
  useSetDeepLink();
  useEffect(() => {
    const tryGetToken = async () => {
      const tokenData = await AsyncStoreService.getTokenData();
      if (!tokenData) {
        await AsyncStoreService.removeUserData();
        dispatch(authActions.getToken(guestTokenUserName, ''));
        //dispatch(authActions.userAuthenticateSuccess(false));
        return;
      }

      // jwt returns expiration 1 year from now, but we have been having timeouts, so this must be wrong.
      // assuming 1 hour timeout and baseing it off of the issued date instead until we find how to handle.
      // const expiryDate = transformedData['.expires'];
      const issuedDate = tokenData['.issued'];
      const expirationDate = moment(new Date(issuedDate)).add(1, 'hours');

      if (expirationDate <= new Date()) {
        await AsyncStoreService.removeUserData();
        dispatch(authActions.getToken(guestTokenUserName, ''));
        //dispatch(authActions.userAuthenticateSuccess(false));
        return;
      } else {
        dispatch(authActions.getTokenSuccess(tokenData));
        const userJson = await AsyncStoreService.getUserData();
        if (userJson) {
          dispatch(getTripCount());
          dispatch(getProfileData());
          dispatch(authActions.userAuthenticateSuccess(userJson));
        }
      }
    };

    const tryLoginWithUrl = async () => {
      try {
        const url = await Linking.getInitialURL();
        const ssoData = getSSOData(url);

        if (!ssoData.isValid) {
          await tryGetToken();
          return;
        }

        dispatch(
          userAuthenticate({
            userName: ssoData.uuid,
            password: ssoData.password,
            isSso: true,
            close: true,
          })
        );
      } catch (e) {
        await tryGetToken();
      }
    };

    tryLoginWithUrl();
  }, [dispatch]);

  return (
    <View style={styles.screen}>
      <ActivityIndicator size="large" color={Color.primary} />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    ...CommonProperties.centerAlignment,
  },
});

export default StartupScreen;
